import { render, staticRenderFns } from "./SeoListView.vue?vue&type=template&id=3b452383&scoped=true"
import script from "./SeoListView.vue?vue&type=script&lang=js"
export * from "./SeoListView.vue?vue&type=script&lang=js"
import style0 from "./SeoListView.vue?vue&type=style&index=0&id=3b452383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b452383",
  null
  
)

export default component.exports